/* eslint-disable */
export default {
  header: 'Contact opnemen met de klantenservice',
  toggleTitle: '1. Schakel de foutopsporingsmodus in',
  toggleDescription:
    'Dit helpt ons om uw problemen te lokaliseren, maar kan de prestaties van uw app enigszins beïnvloeden.',
  downloadTitle:
    '2. Download het foutenlogboek wanneer u het probleem hebt gerepliceerd.',
  downloadButton: 'Downloaden',
  downloadDisabledTitle:
    'Schakel de foutopsporingsmodus in voordat u het foutenlogboek kunt downloaden.',
  sendTitle: '3. Stuur het logboek naar het ondersteuningsteam',
  createSupportTicket: 'Maak een supportticket',
  sendDescription:
    ' om contact op te nemen met ons ondersteuningsteam. Stuur het logboek vervolgens naar het ondersteuningsteam voor probleemoplossing.',
  privacyNotice:
    'Door het logboek te downloaden en naar ons te verzenden, gaat u ermee akkoord dat RingCentral toegang heeft tot bepaalde informatie in het logboek om het oplossen van problemen en fouten te ondersteunen. Raadpleeg voor meer informatie over hoe RingCentral persoonlijke gegevens verwerkt onze ',
  privacyNoticeLink: 'Servicevoorwaarden',
  and: ' en ',
  privacyNoticeEnd: 'Privacyverklaring.',
  needLeavePage:
    'U kunt deze pagina verlaten terwijl het opsporen van fouten wordt uitgevoerd. Wanneer u het probleem hebt gerepliceerd, keert u terug naar deze pagina en downloadt u de logbestanden.',
  downloading: 'Downloaden',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
